module.exports = __webpack_public_path__ + "img/home.8376a190.png";